<template>
  <div class="row sport-header flex-center">
    <div class="grid-left sport-header-name text-cut flex-center-vertical">
      <i
        class="sport-header-icon n-i"
        :class="`n-i-live-${sport.id}`"
      />
      <span class="sport-name text-upper font-italic font-bold">
        {{ sport.name }}
      </span>
      <sport-header-period :id-sport="sport.id" />
    </div>
    <div class="grid-right">
      <div
        class="sport-header-bet"
        v-for="bet in sportBets"
        :key="bet.id">
        <sport-header-bet
          :bet="bet"
          :bet-style="{ betNamePosition: 'left', betIdWidth: 'normal' }"
        />
      </div>
    </div>
  </div>
</template>

<script>
import SportHeaderBet from '@/components/common/sport-header-bet/SportHeaderBet.vue';
import SportHeaderPeriod from '@/components/common/sport-header-period/SportHeaderPeriod.vue';

export default {
  name: 'SportHeader',
  components: { SportHeaderBet, SportHeaderPeriod },
  props: {
    sport: {
      required: true,
      type: Object,
    },
  },
  data() {
    return {
      betsCount: 5,
    };
  },
  computed: {
    sportBets() {
      const bets = this.$store.getters.getActiveSportBets(this.sport.id, this.betsCount);
      this.$store.dispatch('setSportBets', { idSport: this.sport.id, bets });
      return bets;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../assets/style/variables";

.sport-header {
  color: $color-text-primary;
  font-weight: $font-weight-bold;
  @if $sport-header-gradient == false {
    background-color: $sport-header-color-back;
  } @else {
    background-image: $sport-header-color-back-gradient;
  }

  .sport-header-name {
    padding-left: 10px;
    font-size: 0.9375rem;
    font-weight: $font-weight-normal;
  }

  .sport-name {
    line-height: 1;
    padding-left: 10px;
    padding-right: 5px;
    font-size: 0.875rem;
  }

  .sport-header-icon {
    line-height: 1;
    font-size: 0.75rem;
  }

  .sport-header-bet {
    float: left;
    width: 20%;
  }
}

.sport-periods {
  position: absolute;
  bottom: 0;
  right: 0;
}
</style>
